import ForgotPasswordForm from '../components/ForgotPasswordForm';
import LogoFull from '../components/LogoFull';
import { LoginLayoutFrame } from 'app-layout-frame';
import LoginMarketingPane from '../components/LoginMarketingPane';

const ForgotPasswordPage = () => {
    return (
        <LoginLayoutFrame
            logo={<LogoFull />}
            marketingPane={<LoginMarketingPane />}
        >
            <ForgotPasswordForm />
        </LoginLayoutFrame>
    );
};
export default ForgotPasswordPage;
